import { useEffect, useState } from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import { api, compactNumber, formatTL, formatDate } from "@/lib/api";
import { Card } from "@/components/ui/card";

const Kpi = ({ label, value, testId, dark }) => (
  <Card data-testid={testId} className={`p-5 ${dark ? "bg-slate-900 text-white" : ""}`}>
    <div className={`text-xs uppercase tracking-wider mb-2 ${dark ? "text-emerald-400" : "text-slate-500"}`}>{label}</div>
    <div className="text-2xl font-bold" style={{ fontFamily: "Outfit, sans-serif" }}>{value}</div>
  </Card>
);

export default function PlatformFinancePage() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/finance").then(({ data }) => setD(data)); }, []);

  return (
    <div className="space-y-6" data-testid="platform-finance-page">
      <div>
        <div className="text-xs uppercase tracking-wider text-slate-500 font-semibold mb-1">Platform Muhasebe</div>
        <h1 className="text-4xl font-extrabold tracking-tight text-slate-900" style={{ fontFamily: "Outfit, sans-serif" }}>Finansal Raporlar</h1>
        <p className="text-slate-500 mt-1">Abonelik gelirleri. Ofislerin kendi gelir/gider kayıtları burada yer almaz.</p>
      </div>
      {d && (
        <>
          <div className="grid grid-cols-2 lg:grid-cols-5 gap-4">
            <Kpi testId="kpi-total" dark label="Toplam Tahsilat" value={formatTL(d.total_revenue)} />
            <Kpi testId="kpi-month" label="Bu Ay" value={formatTL(d.this_month)} />
            <Kpi testId="kpi-mrr" label="Aylık Beklenen Gelir" value={formatTL(d.monthly_recurring)} />
            <Kpi testId="kpi-overdue" label="Ödenmeyen (Pasif)" value={formatTL(d.overdue_total)} />
            <Kpi testId="kpi-discount" label="Kampanya İndirimi" value={formatTL(d.discount_total)} />
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
            <Card className="p-6">
              <h3 className="font-semibold mb-4">Aylık Tahsilat</h3>
              <ResponsiveContainer width="100%" height={240}>
                <BarChart data={d.by_month}><CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" /><XAxis dataKey="month" fontSize={11} /><YAxis fontSize={11} width={60} tickFormatter={compactNumber} /><Tooltip formatter={(v) => formatTL(v)} /><Bar dataKey="amount" fill="#059669" radius={[4, 4, 0, 0]} /></BarChart>
              </ResponsiveContainer>
            </Card>
            <Card className="p-6">
              <h3 className="font-semibold mb-4">Paket Bazlı Tahsilat</h3>
              <ResponsiveContainer width="100%" height={240}>
                <BarChart data={d.by_package}><CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" /><XAxis dataKey="package" fontSize={11} /><YAxis fontSize={11} width={60} tickFormatter={compactNumber} /><Tooltip formatter={(v) => formatTL(v)} /><Bar dataKey="amount" fill="#2563EB" radius={[4, 4, 0, 0]} /></BarChart>
              </ResponsiveContainer>
            </Card>
          </div>
          <Card className="overflow-hidden">
            <div className="p-5 border-b font-semibold">Son Tahsilatlar</div>
            {d.recent.length === 0 ? <div className="p-8 text-center text-slate-400 text-sm">Kayıt yok.</div> : d.recent.map((p) => (
              <div key={p.id} className="px-5 py-3 border-b last:border-0 flex justify-between text-sm">
                <span>{formatDate(p.paid_at)} · <b>{p.office_name}</b> · {p.package_code}{p.campaign && ` · %${p.campaign.percent} kampanya`}</span>
                <b>{formatTL(p.amount)}</b>
              </div>
            ))}
          </Card>
          {d.overdue.length > 0 && (
            <Card className="overflow-hidden">
              <div className="p-5 border-b font-semibold text-red-700">Ödeme Bekleyen Pasif Ofisler</div>
              {d.overdue.map((o) => (
                <div key={o.office_code} className="px-5 py-3 border-b last:border-0 flex justify-between text-sm"><span>{o.office_name} <span className="font-mono text-xs text-slate-500">{o.office_code}</span></span><b>{formatTL(o.amount)}</b></div>
              ))}
            </Card>
          )}
        </>
      )}
    </div>
  );
}
